import { trackEvent } from '@patrianna/analytics'
import { openDialog } from '@patrianna/dialog-manager'
import { nextTick } from '@patrianna/shared-utils'
import { countdownInHours } from '@patrianna/shared-utils/date'
import { useEffect, useState } from 'react'

import Img from '../Img'

import classes from './styles.module.scss'

type Props = {
  personalExpire: string
}

export default function JackpotBadge(props: Props) {
  const [time, setTime] = useState({ hours: 0, minutes: 0, seconds: 0 })

  useEffect(() => {
    if (props.personalExpire) {
      const interval = setInterval(() => {
        setTime(countdownInHours(props.personalExpire))
      }, 1000)

      return () => clearInterval(interval)
    }

    return undefined
  }, [props.personalExpire])

  const openStashDialog = () =>
    nextTick().then(() => {
      trackEvent('stash_widget_clicked')
      openDialog({ dialogName: 'JACKPOTS_MY_STASH_WAITING_DIALOG' })
    })

  return (
    <button className={classes.root} onClick={openStashDialog} type='button'>
      <picture>
        <Img
          src={`${process.env.IMG_ORIGIN}/shop/gc_icon.png`}
          className={classes.stash}
          alt='stash'
          fallbackImg={`${process.env.IMG_ORIGIN}/shop/gc_icon.png`}
        />
      </picture>
      <span className={classes.timer}>
        {`${time.hours}:`}
        {`${time.minutes < 10 ? `0${time.minutes}` : time.minutes}:`}
        {`${time.seconds < 10 ? `0${time.seconds}` : time.seconds}`}
      </span>
    </button>
  )
}
